import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["data-qa-value", "data-qa"]
const _hoisted_2 = {
  key: 0,
  class: "gfu-payment-tile__labels"
}
const _hoisted_3 = { class: "_flex _ai-c" }
const _hoisted_4 = {
  key: 0,
  class: "gfu-list _mt-4",
  "data-qa": "payment-disclaimer"
}
const _hoisted_5 = { class: "_flex _ai-c" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_label = _resolveComponent("base-label")
  const _component_checkbox_field = _resolveComponent("checkbox-field")
  const _component_base_image = _resolveComponent("base-image")
  const _component_base_icon = _resolveComponent("base-icon")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass($options.methodOptionClassList),
    "data-qa-value": `${$props.isSelected}`,
    "data-qa": `payment-method:${$options.dataQa}`
  }, [
    ($props.paymentMethod.label)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_base_label, {
            theme: $props.paymentMethod.labelTheme,
            "data-qa": `payment-method-label:${$props.paymentMethod.label}`
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString($props.paymentMethod.label), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["theme", "data-qa"])
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", {
      class: "_cur-p _pa-3",
      onClick: _cache[0] || (_cache[0] = $event => (_ctx.$emit('select')))
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_checkbox_field, {
          "model-value": $props.isSelected,
          "show-label": false,
          name: "paymentMethod",
          class: "_mt-0 _mr-2",
          "checked-value": true,
          type: "radio"
        }, null, 8 /* PROPS */, ["model-value"]),
        _createTextVNode(" " + _toDisplayString($props.paymentMethod.name) + " ", 1 /* TEXT */),
        ($props.paymentMethod.imageUrl)
          ? (_openBlock(), _createBlock(_component_base_image, {
              key: 0,
              src: $props.paymentMethod.imageUrl,
              alt: $props.paymentMethod.name,
              width: "34",
              class: "_ml-a",
              "data-qa": "payment-method-image"
            }, null, 8 /* PROPS */, ["src", "alt"]))
          : _createCommentVNode("v-if", true)
      ]),
      ($props.isSelected)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (!!$props.paymentMethod.paymentDisclaimer)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.paymentMethod.paymentDisclaimer, (item) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: item.iconName,
                      class: "_mt-1 _flex"
                    }, [
                      _createVNode(_component_base_icon, {
                        class: "_mr-2 _tc--accent _shrink-0 _py-h",
                        size: "lg",
                        "is-fixed-width": true,
                        name: item.iconName
                      }, null, 8 /* PROPS */, ["name"]),
                      _createElementVNode("div", _hoisted_5, _toDisplayString(item.paragraph), 1 /* TEXT */)
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ]))
              : _createCommentVNode("v-if", true)
          ], 64 /* STABLE_FRAGMENT */))
        : _createCommentVNode("v-if", true)
    ]),
    ($props.isSelected)
      ? _renderSlot(_ctx.$slots, "default", {}, undefined, undefined, 1)
      : _createCommentVNode("v-if", true)
  ], 10 /* CLASS, PROPS */, _hoisted_1))
}